/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable no-debugger */
import React, { useState, useEffect } from 'react';
import { Input, message, Form, Button, Popconfirm, Divider } from 'antd';

import { Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import './form.css'
import { Cards } from '../../../components/cards/frame/cards-frame';


const tLabelClassName = `text-[16px] font-bold text-gray-500 text-wrap`
const tValueClassName = `text-[16px] font-bold text-black text-wrap`

function DataTable() {
  const [form] = Form.useForm();
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(false);
  const [atsNumber, setATSNumber] = useState(0);
  const [compNumber, setCompNumber] = useState(0);
  const [cardNumber, setCardNumber] = useState(0);

  const fetchData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/n-series/query');
      const { data } = response.data;
      // setTableData(data);
      // setTotalRows(total);
      form.setFieldsValue({
        ...data
      })

      setBusy(false)
      setTimeout(() => {
        updateFields();
      }, 500);
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  useEffect(() => {
    fetchData();
    if (reload) setReload(false)
  }, [reload]);

  const handleSubmit = async (values) => {
    try {
      let canContinue = false;
      try {
        const result = await form.validateFields();
        if (result) canContinue = true;
      } catch (error) {
        return
      }
      if (!canContinue) return;

      setBusy(true);
      const payload = form.getFieldsValue();

      const endpoint = '/n-series/create-update';
      const response = await DataService.post(endpoint, payload);

      if (response.data.status) {
        message.success(response.data.message);
      } else {
        message.error(`Error: ${response.data.message}`)
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`)
    }
  };

  const updateFields = async (event) => {
    try {
      // debugger;
      let tempATS = form.getFieldValue('ats_number');
      if (tempATS && String(tempATS).length > 0) {
        tempATS = String(tempATS)
        let appneded0s = "";
        if (tempATS.length < 6) appneded0s += ("0".repeat(6 - tempATS.length))
        tempATS = appneded0s + tempATS
        setATSNumber(tempATS)
      }

      let tempCompReq = form.getFieldValue('comp_reg_number');
      if (tempCompReq && String(tempCompReq).length > 0) {
        tempCompReq = String(tempCompReq)
        let appneded0s = "";
        if (tempCompReq.length < 6) appneded0s += ("0".repeat(6 - tempCompReq.length))
        tempCompReq = appneded0s + tempCompReq
        setCompNumber(tempCompReq)
      }

      let tempCardNumber = form.getFieldValue('card_number');
      if (tempCardNumber && String(tempCardNumber).length > 0) {
        tempCardNumber = String(tempCardNumber)
        let appneded0s = "";
        if (tempCardNumber.length < 6) appneded0s += ("0".repeat(6 - tempCardNumber.length))
        tempCardNumber = appneded0s + tempCardNumber
        setCardNumber(tempCardNumber)
      }

    } catch (error) {
      message.error(`somthing went wrong ${error.message}`)
    }
  }

  // const atsNumber = form.getFieldValue('ats_number');
  // console.log('atsNumber', atsNumber)
  // while (String(atsNumber).length < 5) atsNumber = String(atsNumber).repeat('0')
  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Number Series" routes={[]} />
      <Main>
        <Cards title="Number Series Details" border size="default">

          <Form
            layout="horizontal"
            form={form}
            onFinish={handleSubmit}
            disabled={busy}
            onChange={updateFields}
            labelCol={{ span: 6 }} // Adjust label width
            wrapperCol={{ span: 16 }} // Adjust input width
          >

            <Form.Item
              name="ats_number"
              label="ATS Number"
              rules={[
                {
                  type: 'integer', required: true, validator: (_, value) => {
                    const cnicPattern = /^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$/;
                    const numberPattern = /^[0-9]+$/; // Allows positive integers including 0

                    if (!value) {
                      return Promise.reject(new Error('ATS number is required!'));
                    }
                    if (!numberPattern.test(value)) {
                      return Promise.reject(new Error('ATS number must be a positive number!'));
                    }
                    if (Number(value) < 0) {
                      return Promise.reject(new Error('ATS number must be a positive number!'));
                    }
                    return Promise.resolve();
                  }
                },
              ]}
            >
              <Input placeholder="Enter ATS Number" />
            </Form.Item>

            <Form.Item
              name="comp_reg_number"
              label="Membership Number"
              rules={[
                {
                  type: 'integer', required: true, validator: (_, value) => {
                    const cnicPattern = /^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$/;
                    const numberPattern = /^[0-9]+$/; // Allows positive integers including 0
                    if (!value) {
                      return Promise.reject(new Error('Membership number is required!'));
                    }
                    if (!numberPattern.test(value)) {
                      return Promise.reject(new Error('Membership number must be a positive number!'));
                    }
                    if (Number(value) < 0) {
                      return Promise.reject(new Error('Membership number must be a positive number!'));
                    }

                    return Promise.resolve();
                  }
                },
              ]}
            >
              <Input placeholder="Enter Company Membership Number" />

            </Form.Item>

            <div className="flex flex-col">
              <Form.Item
                name="card_number"
                label="Card Printing Number"
                rules={[
                  {
                    type: 'integer', required: true, validator: (_, value) => {
                      const cnicPattern = /^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$/;
                      const numberPattern = /^[0-9]+$/; // Allows positive integers including 0
                      if (!value) {
                        return Promise.reject(new Error('Card printing number is required!'));
                      }
                      if (!numberPattern.test(value)) {
                        return Promise.reject(new Error('Card printing number must be a positive number!'));
                      }
                      if (Number(value) < 0) {
                        return Promise.reject(new Error('Card printing number must be a positive number!'));
                      }

                      return Promise.resolve();
                    }
                  },
                ]}
              >
                <Input placeholder="Enter Card Printing Number" />

              </Form.Item>
            </div>
          </Form>
          <div className="flex justify-end mr-[90px]">
            <Popconfirm
              title='Are you sure to update record ?'
              onConfirm={handleSubmit}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary" disabled={busy} loading={busy}>
                Update Data
              </Button>
            </Popconfirm>

          </div>
        </Cards>
        <div className="flex flex-col w-full items-center space-y-2 bg-white p-10">
          <h2 className='font-black text-[20px]' >Samples</h2>
          {/* Course Name */}
          <div className="w-full flex justify-between border p-2 rounded border-2 border-orange-100 items-center">
            <div className="w-1/3 text-center">
              <span className={tLabelClassName}>ATS Number:</span>
            </div>
            <div className="w-2/3 text-left mr-5">
              <span className={tValueClassName}>{atsNumber}</span>
            </div>
          </div>
          <div className="w-full flex justify-between border p-2 rounded border-2 border-orange-100 items-center">
            <div className="w-1/3 text-center">
              <span className={tLabelClassName}>Company Registration Number:</span>
            </div>
            <div className="w-2/3 text-left mr-5">
              <span className={tValueClassName}>{compNumber}</span>
            </div>
          </div>
          <div className="w-full flex justify-between border p-2 rounded border-2 border-orange-100 items-center">
            <div className="w-1/3 text-center">
              <span className={tLabelClassName}>Card Printing Number:</span>
            </div>
            <div className="w-2/3 text-left mr-5">
              <span className={tValueClassName}>{cardNumber}</span>
            </div>
          </div>
        </div>
        {/* <div className='flex flex-col space-x-10 bg-white p-10'>
          <div className='flex space-x-10 bg-white p-10'>
            <div className='!flex-1 !flex-grow !shadow-lg !w-[100%] rounded-lg p-10'>
              <div className="flex flex-col items-center">
                <span className='font-bold text-[20px]'>ATS</span>
                <span className='font-bold text-[50px] text-black'>{atsNumber}</span>
              </div>
            </div>
            <div className='!flex-1 !flex-grow !shadow-lg !w-[100%] rounded-lg p-10'>
              <div className="flex flex-col items-center">
                <span className='font-bold text-[20px]'>Compny Registration #</span>
                <span className='font-bold text-[50px] text-black'>{compNumber}</span>
              </div>
            </div>
            <div className='!flex-1 !flex-grow !shadow-lg !w-[100%] rounded-lg p-10'>
              <div className="flex flex-col items-center">
                <span className='font-bold text-[20px]'>Card Number</span>
                <span className='font-bold text-[50px] text-black'>{cardNumber}</span>
              </div>
            </div>
          </div>
        </div> */}
      </Main >
    </>
  );
}

export default DataTable;
